(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-jotform-id]").forEach(function (el) {
      if (el.dataset.loaded === "1") return;
      el.dataset.loaded = "1";

      var s = document.createElement("script");
      s.src = "https://form.jotform.com/jsform/" + el.dataset.jotformId;
      s.async = true;
      el.appendChild(s);
    });
  });
})();